import React from "react";
import {
    Card,
    CardContent,
    Typography,
    Stack,
    Divider,
    Box,
} from "@mui/material";

export default function WindowSummary(props) {
    const {
        darkState,
        title = "RF WINDOWS",
        totalCount,
        openCount,
        totalQty,
        openQty,
        glassTypeBreakdown = {},
        details = [],
        rawWindowData = [],
    } = props;

    return (
        <Card
            variant="outlined"
            sx={{
                mt: 0,
                mb: 1,
                width: "100%",
                border: darkState ? "1.5px solid" : "3px solid",
                borderColor: "primary.main",
                borderRadius: "16px",
            }}
        >
            <CardContent
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                }}
            >
                <Typography
                    variant="h3"
                    color="text.primary"
                    sx={{
                        fontWeight: 700,
                        fontSize: { xs: "2rem", sm: "2.5rem" }, // Larger font size
                        textAlign: "center",
                    }}
                >
                    {title}
                </Typography>
                <Divider sx={{ my: 0.5, width: "100%" }} />
                <Stack
                    direction="row"
                    spacing={{ xs: 2, sm: 4 }}
                    sx={{ mt: 1, mb: 2 }}
                >
                    <Stack alignItems="center">
                        <Typography
                            variant="h6"
                            color="text.primary"
                            sx={{ fontSize: { xs: "0.875rem", sm: "1.25rem" } }}
                        >
                            Total {(totalCount || 0) === 1 ? "Order" : "Orders"}
                        </Typography>
                        <Typography
                            variant="h4"
                            color="text.secondary"
                            sx={{
                                fontWeight: 600,
                                fontSize: { xs: "1.75rem", sm: "2.125rem" },
                            }}
                        >
                            {totalCount || 0}
                        </Typography>
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                        >
                            ({totalQty || 0}{" "}
                            {(totalQty || 0) === 1 ? "window" : "windows"})
                        </Typography>
                    </Stack>
                    <Divider orientation="vertical" flexItem />

                    <Stack alignItems="center">
                        <Typography
                            variant="h6"
                            color="warning.main"
                            sx={{ fontSize: { xs: "0.875rem", sm: "1.25rem" } }}
                        >
                            Open {(openCount || 0) === 1 ? "Order" : "Orders"}
                        </Typography>
                        <Typography
                            variant="h4"
                            color="warning.main"
                            sx={{
                                fontWeight: 600,
                                fontSize: { xs: "1.75rem", sm: "2.125rem" },
                            }}
                        >
                            {openCount || 0}
                        </Typography>
                        <Typography
                            variant="body2"
                            color="warning.main"
                            sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                        >
                            ({openQty || 0}{" "}
                            {(openQty || 0) === 1 ? "window" : "windows"})
                        </Typography>
                    </Stack>
                </Stack>

                {details
                    .filter((text) => Boolean(text))
                    .map((text, index) => (
                        <Typography
                            key={`window-summary-detail-${index}`}
                            variant="caption"
                            color="text.secondary"
                            gutterBottom
                        >
                            {text}
                        </Typography>
                    ))}
            </CardContent>
        </Card>
    );
}
